export default __webpack_public_path__ + "static/media/dbg.1a730086.svg";